import geometry from './data/geometry.json';

function computeSlots(layout){
    const slots = [];
    
    Object.keys(geometry).forEach(key=>{
        const group = layout.filter(s=>s.ParentName === key && s.uiCoord.x !== null).map(slot=>{
            if(slot.Name === 'LM01Snapvtopslot001'){
                console.log('found slot__________', slot)
            }
            
            return {
                radius: slot.Type === 'snapvialslot' || slot.Type === 'snapvtopslot' ? 8 : 13,
                //x: slot.uiCoord?slot.uiCoord.x:slot.Coord.x+250,
                //y: slot.uiCoord?slot.uiCoord.y:slot.Coord.y+250,
                x: slot.uiCoord.x,
                y: slot.uiCoord.y,

                labels: getLabels(slot),
                slotType: slot.Type,
                name: slot.Name,
                parent: key,
                selected: false,
                hidden: slot.hidden
            };
        })
        console.log(key, group)
        //invert(group);
        normalizeCoordinates(group, geometry[key].offsetX, geometry[key].offsetY, geometry[key].width, 'x', 'y');
        if(key === 'ExtractionTubeRack01'){
            group.forEach(slot=>{
                slot.doorClosedX = -slot.x;
                slot.doorClosedY = slot.y;
            });
            normalizeCoordinates(group, geometry[key].offsetX, geometry[key].offsetY, geometry[key].width, 'doorClosedX', 'doorClosedY');
        }
        slots.push(...group)
    })

    function getLabels(slot) {
        const labels = [];
        if(slot.ParentName === 'ExtractionTubeRack01'){
            labels.push({
                text: slot.Name.match(/ETR01Extubeslot0*(\d*)/)[1],
                x: 0,
                y: -1.4,
                size: 1
            })
        }
        if(slot.ParentName === 'SnapVialRack01' && slot.Name.match(/SVR01SnapvtopslotA/)){
            labels.push({
                text: slot.Name.match(/SVR01SnapvtopslotA0*(\d*)/)[1],
                x: 0,
                y: -2,
                size: 2
            })
        }
        if(slot.ParentName === 'SnapVialRack01' && slot.Name.match(/.*(.)001/)){
            labels.push({
                text: slot.Name.match(/.*(.)001/)[1],
                x: -2.3,
                y: 0.5,
                size: 2
            })
        }
        return labels.length?labels:[{
            text: '',
            x: 0,
            y: 0,
            size: 1
        }]
    }
    /*
    layout.forEach(obj=>{
        if(modules[obj.ParentName]){
            modules[obj.ParentName].slots[obj.Name] = {
                x: obj.UICoord?obj.UICoord.x:obj.originalCoord.x,
                y: obj.UICoord?obj.UICoord.y:obj.originalCoord.y,
                
                state: 'empty',
                type: 'undefined',
                slotType: obj.Type,
                lid: '',
                selected: false
            };
        }
    })*/

    function normalizeCoordinates(slots, x, y, width, xKey, yKey){
        let minX, minY, maxX, maxY;
        slots.forEach(slot=>{
            if(slot[xKey] < minX || !minX){
                minX = slot[xKey];
            }
            if(slot[yKey] < minY || !minY){
                minY = slot[yKey];
            }
            if(slot[xKey] > maxX || !maxX){
                maxX = slot[xKey];
            }
            if(slot[yKey] > maxY || !maxY){
                maxY = slot[yKey];
            }
        })
        let diffX = maxX - minX;
        let diffY = maxY - minY;
        let diff = diffX / width;
        if(!diff){
            diff = 1;
        }
        console.log(minX, minY, diffX, diffY)
        slots.forEach(slot=>{
            slot[xKey] = (slot[xKey] - minX) / diff + x;
            slot[yKey] = (maxY - slot[yKey]) / diff + y;
        })
    }

    function invert(slots){
        slots.forEach(slot=>{
            slot.y = -slot.y;
        })
    }
    /*
    Object.keys(modules).forEach(key=>{
        group.geometry = geometry[key] || {viewBox: '-500 -500 1000 1000', outline: '', radius: 20};
        invert(group.slots);
        //normalizeCoordinates(group.slots, -800, -800, 1600);
    });
    */
    console.log(slots)
    return slots;
}



export default computeSlots;